import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";
import Crop from "../../shared/crop";
import Select from "react-select";

const AddCategory = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState("");
  const [isError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    image: "",
    image_url: ""
  });

  const onSave = () => {
    if (formValue.name) {
      setError(false);
      setLoading(true);
      const pUrl = id ? API_URL.CATEGORY_UPDATE : API_URL.CATEGORY_SAVE;
      axios.post(pUrl, formValue).then((res) => {
        if (res.data.status === 1) {
          let message = id
            ? "Category Updated Successfully."
            : "Category Created Successfully.";
          toast.success(message, { autoClose: 3000, position: "top-right" });
          setLoading(false);
          navigate("/category");
        }
      })
        .finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.CATEGORY_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          image: null,
          image_url: res.data.data.image ? res.data.data.image : "",
        });
      }
    });
  };
  const isRequiredField = (key) => {
    return isError && !formValue[key];
  };

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} Category</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/category"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Name<span className="required-star">*</span></label>
                      <input
                        type="text"
                        name="name"
                        value={formValue.name}
                        className={
                          isRequiredField("name")
                            ? "form-control required"
                            : "form-control"
                        } id="name"
                        onChange={(event) => {
                          setFormValue({
                            ...formValue,
                            name: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  {/* <div className="col-md-3">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Image</label>
                          <Crop
                            imagePreview={imagePreview}
                            cropShape={"round"}
                            guid={""}
                            onChangeCropper={async ({
                              fileCropped,
                              fileCroppedBase64,
                            }) => {
                              setFormValue({
                                ...formValue,
                                image: fileCroppedBase64,
                              });
                              setImagePreview(fileCroppedBase64);
                              //   await uploadFile(fileCropped)
                            }}
                          />
                        </div>
                      </div>
                      {id && (
                        <div className="col-md-12">
                          <label>Preview</label>
                          <div>
                            <a
                              href={formValue.image_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={formValue.image_url}
                                height={100}
                                width={100}
                                alt="product_image"
                              />
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </div> */}
                  <div className="col-lg-4 form-group text-left">
                    <button
                      type="submit"
                      onClick={onSave}
                      disabled={loading}
                      className="btn btn-primary mt-4"
                    >
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCategory;
